import { useEventListener } from 'ahooks'

export function useWindowFocus(callback: () => void) {
  useEventListener('focus', callback, { target: window })
}
